<template>
    <div class="common_container">
        <el-form  ref="form" :model="form" label-width="80px" class="icon-form">
           <el-row>
                <el-col :span="12">
                    <el-form-item label="图标名称">
                        <el-input type="text" placeholder="请输入图标名称" v-model="form.title" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
           </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="图标类型">
                       <el-select v-model="form.iconType" placeholder="请选择图标类型" class="form-input">
                           <el-option v-for="item in iconType" :label="item.cname" :key="item.id" :value="item.id"></el-option>
                       </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="图标">
                        <!--<inputFile :data="attachment" :getFiles="getFiles"></inputFile>-->
                        <uploadIcon :data="attachment" :getFiles="getFiles"></uploadIcon>
                    </el-form-item>

                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit">确定</el-button>
                <el-button type="default" size="small" @click="oncancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import inputFile from "../common/inputFile.vue"
    import uploadIcon from "./uploadIcon.vue"
    import services from './system.service'
    export default {
        name: "iconAdd",
        components:{inputFile,uploadIcon},
        props:{
            callback:Function
        },
        data(){
          return{
              formName:'form',
              form:{
                  title:'',
                  iconType:'',
              },
              // iconType:[
              //     {id:1,cname:'系统图标'},
              //     {id:2,cname:'配置项分类图标'},
              //     {id:3,cname:'知识分类图标'}
              // ],
              attachment:[]
          }
        },
        created(){
            // console.log(this.dictionary,'字典');
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            iconType(){
                return this.dictionary.icon_type
            }
        },
        methods:{
            getFiles(val){
                this.attachment = val;
            },
            submit(){
                let formName = this.formName;
                this.$refs[formName].validate((valid)=>{
                    if (valid){
                        let params =this.getParams()
                        this.addIcon(params)
                    }
                })
            },
            getParams(){
                let params={
                    title:this.form.title,
                    iconType:this.form.iconType,
                    url:this.attachment&&this.attachment[0].url
                }
                return params
            },
            addIcon(params){
              services.addIcon(params).then((res)=>{
                  this.$message.success('图标创建成功')
                  this.close(true)
              }).catch((err)=>{
                  this.$message.error(err.message)
              })
            },
            oncancel(){
                this.close()
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        },


    }
</script>

<style scoped>

</style>
